import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: UserState = {
  id: null,
  mobile: null,
  createdAt: null,
  updatedAt: null,
  firstName: null,
  lastName: null,
  email: null,
  identityType: null,
  identityNumber: null,
  birthDate: null,
  nationality: null,
  role: null,
  isVerified: null,
  code: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearUser: (state) => {
      Object.entries(state).forEach(
        ([k]) => (state[k as keyof UserState] = null)
      );
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
